module.exports = " <div> Vue Template </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.1.6.1@eslint-loader!./src/views/sub/Password.vue
// module id = 287
// module chunks = 2